import { render, staticRenderFns } from "./SquareArrowButton.vue?vue&type=template&id=57546a1c&scoped=true&name=square-arrow-button&"
import script from "./SquareArrowButton.vue?vue&type=script&lang=js&"
export * from "./SquareArrowButton.vue?vue&type=script&lang=js&"
import style0 from "./SquareArrowButton.vue?vue&type=style&index=0&id=57546a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57546a1c",
  null
  
)

/* custom blocks */
import block0 from "./SquareArrowButton.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports